import { render, staticRenderFns } from "./BonusRecords.vue?vue&type=template&id=d2e8596e&scoped=true"
import script from "./BonusRecords.vue?vue&type=script&lang=js"
export * from "./BonusRecords.vue?vue&type=script&lang=js"
import style0 from "./BonusRecords.vue?vue&type=style&index=0&id=d2e8596e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2e8596e",
  null
  
)

export default component.exports